import classNames from "classnames";
import React from "react";

interface Props {
  fileId: string
  clearButtonAlign: "left" | "center"
  onFileRemoved: () => void
}

const UploadedSignatureFile = (props: Props) => {
  const [imgUrl, setImgUrl] = React.useState<string>("");

  React.useEffect(() => {
    setImgUrl(window.CoreApi.UserSignature.DownloadSignatureFile.absoluteUrl(props.fileId));
  }, [props.fileId]);

  const classes = classNames("margin-top-small", {
    "flex justify-center": props.clearButtonAlign === "center"
  });

  return <>
    <div className="upload-signature-file" style={{ textAlign: "center" }}>
      <img src={imgUrl} style={{ maxHeight: 150 }} />
    </div>
    <div className={classes}>
      <div>
        <a onClick={props.onFileRemoved}>{RESX.GeneralLabels.clear}</a>
      </div>
    </div>
  </>;
};

export default UploadedSignatureFile;